<template>
  <div class="na">
    <img class="na__header" src="@/static/image/NeteaseActivity-header.png" />
    <div class="na__fixrt">
      <div class="na__fixrtitem" @click="openRule">规则说明</div>
      <div class="na__fixrtitem" @click="share" v-if="isApp"><img src="@/static/image/share-icon.png" />分享</div>
    </div>
    <div class="na__info info">
      <div class="info__user user" v-if="vipCode">
        <img class="user__img" v-if="headImg" :src="headImg">
        <img class="user__img" v-else src="@/static/image/default-user-portrait.png">
        <div class="user__info">
          <div>
            极氪订阅账号：{{ (realPhone + '').replace(/\d{4}(?=\d{4}$)/, '****') }}
          </div>
          <div>
            网易严选账号：{{ (realPhone + '').replace(/\d{4}(?=\d{4}$)/, '****') }}
          </div>
        </div>
      </div>
      <div class="info__btn info__btn--buyed" v-if="hasOrder" @click="startPayCenter">已购买，查看订阅特权</div>
      <div class="info__btn info__btn--buy" v-else @click="startPayCenter">立即购买</div>
      <div class="info__rule">购买即视为同意<span @click="toPolicyPage('TK016')">《极氪订阅特权用户协议》</span></div>
    </div>
    <div class="card">
      <div class="card__title">
        <div class="card__titlebefore"></div>
        极氪订阅特权
        <div class="card__titleafter"></div>
      </div>
      <div class="card__subtitle">{{ subscribeList.length }}项订阅权益</div>
      <div class="card__list">
        <div class="card__item" v-for="item in subscribeList" :key="item.name" @click="openCouponsDetail(item)">
          <img class="card__itemicon" :src="'/images/' + item.icon" alt="">
          <div class="card__itemname">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="card card--gold">
      <div class="card__title">
        <div class="card__titlebefore"></div>
        网易严选Pro会员
        <div class="card__titleafter"></div>
      </div>
      <div class="card__subtitle">{{ netList.length }}项会员权益</div>
      <div class="card__list">
        <div class="card__item" v-for="item in !showMore ? netList.slice(0, 10) : netList" :key="item.name">
          <img class="card__itemicon" :src="'/images/' + item.icon" alt="">
          <div class="card__itemname">{{ item.name }}</div>
        </div>
      </div>
      <div class="card__more" v-if="!showMore" @click="showMore = !showMore">更多</div>
      <div class="card__hint">*实际权益以网易严选App展示内容为准</div>
    </div>
    <couponsDetail ref="couponsDetailRef"></couponsDetail>
    <ruleDetail ref="ruleRef"></ruleDetail>
    <reloadHint ref="reloadHintRef"></reloadHint>
  </div>
</template>
<script setup>

import * as api from "@/api/otherOrder";
import { ref } from "vue";
import Ditto from '@zeekr-f2e/zeekr-ditto'
import { useRouter } from "vue-router";
import { getCurrentInstance } from 'vue';
import subscribeList from './subscribeList';
import { Toast } from 'vant';
import couponsDetail from './couponsDetail';
import ruleDetail from './ruleDetail';
import reloadHint from './reloadHint';
const router = useRouter();

const couponsDetailRef = ref(null)
const ruleRef = ref(null)
const reloadHintRef = ref(null)
const realPhone = ref("")
const phone = ref("")
const vipCode = ref("")
const headImg = ref("")
const isApp = ref(/ZEEKR-APP-(\w+)/.test(navigator.userAgent)) // 是否处于极氪订阅app当中
const hasOrder = ref(false) // 当前登录用户是否有订单
const showMore = ref(false) // 查看更多pro会员内容
const share = () => {
  Ditto.registerParams('common_js.shareSelector', {
    title: '极氪订阅×网易严选联合特权来啦！',
    des: '开通即享26项专属联合特权，7*24小时贴心服务！',
    url: process.env.VUE_APP_ZEEKR_WEB_ADDRESS + '/NeteaseActivity',
    shareType: 3,
    imgUrl: 'https://zeekrgo-cdn.zeekrlife.com/miniapp-ico/images/netease-activity-share.png'
    // // 标题
    // var title:String?
    // // 副标题
    // var des:String?
    // // h5链接
    // var url:String?
    // // 缩略图
    // var imgUrl:String?
    // // 1文字 2图片 3H5
    // var shareType:Int?
    // // 是否需要在分享按钮上方预览分享的图片
    // var showImg: Bool?
  })
}

// 网易严选Pro会员权益列表
const netList = [
  {
    icon: 'net-rights-1.png',
    name: '天天免邮'
  },
  {
    icon: 'net-rights-2.png',
    name: '每月0元领'
  },
  {
    icon: 'net-rights-3.png',
    name: 'Pro95折'
  },
  {
    icon: 'net-rights-4.png',
    name: '新品抢先'
  },
  {
    icon: 'net-rights-5.png',
    name: '每月专享券'
  },
  {
    icon: 'net-rights-6.png',
    name: '每日闪购'
  },
  {
    icon: 'net-rights-7.png',
    name: '双倍积分'
  },
  {
    icon: 'net-rights-8.png',
    name: '专属客服'
  },
  {
    icon: 'net-rights-9.png',
    name: '先享后付'
  },
  {
    icon: 'net-rights-10.png',
    name: '不回本可退'
  },
  {
    icon: 'net-rights-11.png',
    name: '退换免运费'
  },
  {
    icon: 'net-rights-12.png',
    name: '极速售后'
  },
  {
    icon: 'net-rights-13.png',
    name: '3天可退'
  },
  {
    icon: 'net-rights-14.png',
    name: 'Pro会员日'
  },
  {
    icon: 'net-rights-15.png',
    name: '积分专属兑'
  },
  {
    icon: 'net-rights-16.png',
    name: '亲友邀请卡'
  },
]

const checkValidOrdering = ref(false) // 是否正在获取订单信息中
const checkValidOrder = () => {
  checkValidOrdering.value = true
  api.checkValidOrder({
    orderType: 1,	// 订阅增值业务订单订单类型，1-网易严选联合会员购买	
    vipCode: vipCode.value,	// 用户vipCode
  }).then(
    (res) => {
      if (res.status === 200 && res.data.code === "0") {
        if (res.data.body.hasValidOrder) {
          hasOrder.value = true
        }
      } else {
        Toast(res.data && res.data.msg || '订单查询失败')
      }
      checkValidOrdering.value = false
    }, () => {
      Toast('订单查询失败')
      checkValidOrdering.value = false
    }
  );
}

const getUserInfo = () => {
  Ditto.registerParams('common_js.getUserInfo').then(res => {
    if (res) {
      if (res.vipCode) {
        vipCode.value = res.vipCode
        realPhone.value = res.realPhone || ''
        phone.value = res.phone || ''
        headImg.value = res.headImg || ''
        checkValidOrder()
      }
    }
  })
}
// 在app中 获取用户信息
if (isApp.value) {
  getUserInfo()
}
const paying = ref(false)
// 付款
const startPayCenter = () => {
  if (isApp.value) {
    // 仅在app中且获取了订单信息后继续
    if (checkValidOrdering.value) {
      return
    }
    // 处于app中且未登录
    if (!vipCode.value) {
      const _data = {
        path: 'subscription_biz_mine.ZUSubscriptionLoginViewController'
      }
      Ditto.openNative({
        protocol: "app://route/openNative?path=/subscription/login&data=" + JSON.stringify(_data)
      })
      return
    }
    // 如果已有订单,跳转到历史页中
    if (hasOrder.value) {
      router.push({
        name: "NeteaseHistory",
      });
      return
    }
    // 正在获取用户订单信息中
    if (checkValidOrdering.value) return
    // 正在支付中
    if (paying.value) return
    paying.value = true
    api.create({
      orderType: 1,	// 订阅增值业务订单订单类型，1-网易严选联合会员购买	
      channelSource: 1, // 渠道，1=订阅app，2=微信小程序，3=极氪app，4=支付宝小程序	
      phone: phone.value,	// 手机号，未加密	
      terminalType: 1,	// 终端类型：1-APP，2-PC，3-微信小程序，4-Pad，5-支付宝小程序	
      vipCode: vipCode.value,	// 用户vipCode
    }).then(
      (res) => {
        if (res.status === 200 && res.data.code === "0") {
          Ditto.registerParams('subscription.startPayCenter', res.data.body).then(() => {}, err => {
            Toast('订单创建失败')
          })
        } else if ('已购买，请不要重复购买' === (res.data && res.data.msg)) {
          openReload()
        } else {
          Toast(res.data && res.data.msg || '订单创建失败')
        }
        paying.value = false
      }, () => {
        Toast('订单创建失败')
        paying.value = false
      }
    );
  } else { // 未处于app中
    router.push({
      name: "DownloadGuidance",
    });
  }
}
const toPolicyPage = (clauseCode) => {
  router.push({
    name: "PolicyPage",
    params: {
      id: clauseCode,
    },
    query: {
      token: "421459faa4e1f6d564f67d138620be8d",
      mode: "dark",
    },
  });
}
const openCouponsDetail = (item) => {
  couponsDetailRef.value.open({
    title: item.name,
    content: item.content,
  })
}
const openRule = () => {
  ruleRef.value.open()
}
const openReload = () => {
  reloadHintRef.value.open()
}

</script>
<style scoped>
.na {
  background: #0b0b0b;
  width: 100vw;
  height: 100vh;
  overflow: auto;
}

.na__header {
  width: 100%;
  vertical-align: middle;
}

.info {
  padding: 0 60px;
  background: url('@/static/image/NeteaseActivity-info.png') center top / 100% no-repeat;
  height: 435px;
  border-radius: 8px;
  margin: 0 30px 30px;
  color: #A2A3A4;
  font-size: 24px;
  position: relative;
  box-sizing: border-box;
  padding-top: 260px;
  text-align: center;
}

.info__btn {
  box-sizing: border-box;
  border-radius: 8px;
  height: 88px;
  color: #121415;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 20px;
  position: relative;
}

.info__btn.info__btn--buy {
  background: linear-gradient(to bottom, #eee, #aaa);
  border: 1px solid #fff;
}

.info__btn.info__btn--buy::after {
  content: '';
  position: absolute;
  right: -17px;
  top: -26px;
  width: 170px;
  height: 80px;
  background: url('@/static/image/economize199.png') center / 100% no-repeat;
}

.info__btn--buyed {
  background: linear-gradient(176.96deg, rgba(255, 255, 255, 0.08) -19.86%, rgba(154, 161, 170, 0.08) 79.35%);
  color: #BDC0C4;
  border: 1px solid #BDC0C4;
}

.info__btn--buyed::after {
  content: '';
  width: 28px;
  height: 28px;
  background: url('@/static/image/ico-arrow-r.png') center / 100% no-repeat;
  display: inline-block;
  margin-left: 8px;
}

.info__rule {
  color: #747676;
  font-size: 24px;
}

.info__rule span {
  color: #A2A3A4;
}

.info__user {
  position: absolute;
  top: 1px;
  left: 0;
  right: 0;
  margin: auto;
  background-color: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(40px);
  width: 570px;
  font-size: 24px;
  color: #A2A3A4;
  transform: translate(0, -100%);
  border-radius: 8px 8px 0 0;
  padding: 16px 30px;
  display: flex;
  align-items: center;
}

.user__info {
  border-left: 1px solid #454849;
  line-height: 40px;
  flex-grow: 1;
  text-align: left;
  padding-left: 30px;
}

.user__img {
  width: 68px;
  height: 68px;
  margin-right: 30px;
  flex-shrink: 0;
  border-radius: 50%;
}

.na__fixrt {
  position: absolute;
  top: 30px;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 1;
}

.na__fixrtitem {
  justify-content: center;
  background: #232323;
  border-radius: 28px 0 0 28px;
  height: 56px;
  line-height: 56px;
  color: #9DA2A5;
  font-size: 24px;
  padding: 0 20px;
}

.na__fixrtitem+.na__fixrtitem {
  margin-top: 30px;
}

.na__fixrtitem img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.card {
  background: #171A1B;
  background: linear-gradient(to bottom, #2a2d2e 0, #171A1B 200px, #171A1B);
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  margin: 30px;

}

.card__title {
  color: #BDC0C4;
  font-weight: bold;
  font-size: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card__titlebefore,
.card__titleafter {
  margin: 0 12px;
  display: flex;
  align-items: flex-start;
}

.card__titlebefore::before,
.card__titleafter::before {
  content: '';
  display: block;
  width: 7px;
  height: 16px;
  background: linear-gradient(to bottom, #BDC0C4, rgba(0, 0, 0, 0));
  transform: skewX(45deg);
  margin: 0 3px;
}

.card__titleafter::before {
  transform: skewX(-45deg);
  height: 12px;
  ;
}

.card__titlebefore::after,
.card__titleafter::after {
  content: '';
  display: block;
  width: 7px;
  height: 12px;
  background: linear-gradient(to bottom, #BDC0C4, rgba(0, 0, 0, 0));
  transform: skewX(45deg);
  margin: 0 3px;
}

.card__titleafter::after {
  transform: skewX(-45deg);
  height: 16px;
}

.card__subtitle {
  color: #BDC0C4;
  opacity: 0.6;
  margin-top: 10px;
  font-size: 24px;
  margin-bottom: 30px;
}

.card__itemicon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  margin: 0 auto 20px;
}

.card__list {
  text-align: left;
}

.card__item {
  text-align: center;
  width: 20%;
  display: inline-block;
  color: #A2A3A4;
  font-size: 24px;
  padding: 30px 0;
}

.card--gold {
  background: linear-gradient(to bottom, #252521 0, #171A1B 200px, #171A1B);
}

.card--gold .card__title {
  color: #F3CA84;
}

.card--gold .card__subtitle {
  color: #F3CA84;
}

.card--gold .card__titlebefore::before,
.card--gold .card__titleafter::before,
.card--gold .card__titlebefore::after,
.card--gold .card__titleafter::after {
  background: linear-gradient(to bottom, #F3CA84, rgba(0, 0, 0, 0));
}

.card__more {
  color: #A2A3A4;
  font-size: 24px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card__more::after {
  content: '';
  width: 20px;
  height: 20px;
  background: url('@/static/image/ico-arrow-r.png') center / 100% no-repeat;
  display: block;
  transform: rotate(90deg);
  margin-left: 8px;
}

.card__hint {
  font-size: 20px;
  color: #747676;
}
</style>
